import Modal from "components/DesignSystem/Modal/Modal";
import { ModalProps } from "types/utils/modal";
import { Dollar } from "components/icons/Dollar";
import { GreentickGreenCircle } from "components/icons/GreentickGreenCircle";
import { PaperPencil } from "components/icons/PaperPencil";
import { PaperWithCross } from "components/icons/PaperWithCross";
import { PaperWithTick } from "components/icons/PaperWithTick";
import { PersonWithClock } from "components/icons/PersonWithClock";

const GuideCard = ({
  icon,
  title,
  description,
}: {
  icon: React.JSX.Element;
  title: string;
  description: string;
}) => (
  <div className="t-p-3 t-rounded t-border t-border-solid t-border-neutral-0 t-flex t-gap-3">
    <div className="t-flex-shrink-0">{icon}</div>
    <div className="t-space-y-1.5">
      <div className="t-text-subtitle-sm t-text-text-60">{title}</div>
      <div className="t-text-body-sm t-text-text-30">{description}</div>
    </div>
  </div>
);

export const TaskStatusGuide = ({ isOpen, close }: ModalProps) => {
  const taskStateDetails = [
    {
      title: "Pending payment",
      description:
        "This filing hasn’t been purchased yet. Please complete payment to begin your filing process.",
      icon: (
        <div className="t-h-8 t-w-8 t-rounded-full t-bg-orange-10 t-flex t-items-center t-justify-center">
          <Dollar className="t-text-orange-80" />
        </div>
      ),
    },
    {
      title: "Add details",
      description:
        "We need a few details from you before we can proceed. Please review and complete the pending information.",
      icon: (
        <div className="t-h-8 t-w-8 t-rounded-full t-bg-orange-10 t-flex t-items-center t-justify-center">
          <PaperPencil className="t-text-orange-80" />
        </div>
      ),
    },
    {
      title: "Filing in progress",
      description:
        "Your filing is currently in progress. Our team is preparing your draft and will update you once it’s ready.",
      icon: (
        <div className="t-h-8 t-w-8 t-rounded-full t-bg-orange-10 t-flex t-items-center t-justify-center">
          <PersonWithClock className="t-text-orange-80" />
        </div>
      ),
    },
    {
      title: "Amendment in progress",
      description:
        "An amendment for your filing is underway. Our team is updating your details and will share progress soon.",
      icon: (
        <div className="t-h-8 t-w-8 t-rounded-full t-bg-orange-10 t-flex t-items-center t-justify-center">
          <PaperWithCross className="t-text-orange-80" />
        </div>
      ),
    },
    {
      title: "Filing completed",
      description:
        "Your filing has been successfully completed. You can view the filed copy in your dashboard.",
      icon: (
        <div className="t-h-8 t-w-8 t-rounded-full t-bg-green-20 t-flex t-items-center t-justify-center">
          <GreentickGreenCircle className="t-text-green-80" />
        </div>
      ),
    },
    {
      title: "Amendment filed",
      description:
        "The amendment has been successfully completed. You can access the updated filing details in your dashboard.",
      icon: (
        <div className="t-h-8 t-w-8 t-rounded-full t-bg-green-20 t-flex t-items-center t-justify-center">
          <PaperWithTick className="t-text-green-80" />
        </div>
      ),
    },
  ];

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Filing Status</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-space-y-3">
            {taskStateDetails.map(({ title, description, icon }, index) => (
              <GuideCard
                key={index}
                icon={icon}
                title={title}
                description={description}
              />
            ))}
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
